// extracted by mini-css-extract-plugin
export default {"wrapper":"PwaForm_wrapper__bBxNB","title":"PwaForm_title__fBD90","container":"PwaForm_container__vB5Ss","content":"PwaForm_content__pdS53"};